<template>
  <v-app>
    <ticket-app-title-bar />
    <v-main>
      <v-container fluid>
        <v-fade-transition appear hide-on-leave leave-absolute>
          <router-view name="default" key="site-router" />
        </v-fade-transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
  import { computed, defineComponent } from "vue";
  import { useRoute } from 'vue-router/composables'
  import ticketAppTitleBar from "./views/ticket-app-title-bar.vue";

  export default defineComponent({
    name: 'main-application',
    components: { ticketAppTitleBar },
  });
</script>